export const getHasAncestryData = (ancestries) => ![...new Set(ancestries)].every((entry) => (entry === undefined || entry === 'Unspecified'));
